import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/tradepassport-empty-thumbnail.png'


const _withScopeId = n => (_pushScopeId("data-v-b1257a12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "trade__insurance__wrapper tw-max-w-[1300px] tw-w-full md:!tw-pb-[4rem] md:!tw-box-border"
}
const _hoisted_3 = { class: "tw-w-full tw-rounded-lg tw-bg-[#F8FBFD] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-3" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-justify-between tw-pb-3 tw-box-border tw-border-b-dashed-custom" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-2 tw-justify-start" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-w-full" }
const _hoisted_7 = { class: "tw-flex tw-items-start tw-gap-3 tw-w-full md:!tw-gap-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-min-w-[68px] tw-w-[68px] tw-h-[68px] tw-rounded-[4.85px] tw-bg-[rgba(12,15,74,0.04)] tw-border-solid tw-border-[#DFDFDF] tw-border-[1px] tw-overflow-hidden md:!tw-min-w-[55px] md:!tw-w-[55px] md:!tw-h-[55px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "tw-w-full tw-h-full tw-object-cover"
  })
], -1))
const _hoisted_9 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-1" }
const _hoisted_10 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-[.1rem] tw-items-start" }
const _hoisted_11 = { class: "tw-flex tw-items-start tw-gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2 md:!tw-gap-1"
}
const _hoisted_13 = {
  key: 2,
  class: "empty__content !tw-pb-12 !tw-box-border !tw-h-auto tw-w-full"
}
const _hoisted_14 = { class: "empty__banner tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4" }
const _hoisted_15 = { class: "empty__banner__img md:!tw-w-[50%]" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "empty__banner__content"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "You don't have any Insurance yet!", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You haven't added any insurance details yet. Upload your insurance to build trust and meet industry standards.\" ", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "empty__banner__content"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Don't have any Insurance yet!", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "haven't added any insurance details to this profile yet", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "empty__banner__footer tw-w-full" }

import { computed, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { USER_STORE } from "@/store/modules/user";
import ItemListCard from "@/core/components/ItemListCard.vue";
import InsuranceModel from "@/modules/insurance/components/InsuranceModel.vue";
import { WORKSTATION } from "@/store/modules/workstation";
import { isExpiredDate } from "@/core/utils/common";
import {
  UserRolesEnum,
  UserVerificationStatusEnum,
} from "@/core/enums/RolesEnum";
import AcceptChip from "@/modules/dashboard/components/Chips/AcceptChip.vue";
import RejectChip from "@/modules/dashboard/components/Chips/RejectChip.vue";
import PendingChip from "@/modules/dashboard/components/Chips/PendingChip.vue";
// import CommonChip from "@/modules/dashboard/components/Chips/CommonChip.vue";
import ConfirmDeleteModal from "@/modules/dashboard/components/Modals/ConfirmDeleteModal.vue";
import insurancesService from "@/core/services/insurances.service";
import { INSURANCE_STORE } from "@/store/modules/insurance";
import Loader from "@/core/components/common/Loader.vue";
import TradeWelcomeBoard from "./cards/TradeWelcomeBoard.vue";
import PendingVerifyNotice from "./cards/PendingVerifyNotice.vue";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import AddInsuranceModal from "@/modules/insurance/components/AddInsuranceModal.vue";
import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import appFilters from "@/filters";
import BlueCircularPencilIcon from "@/core/components/icons/BlueCircularPencilIcon.vue";
import GrayCircularTrashIcon from "@/core/components/icons/GrayCircularTrashIcon.vue";
import { TRADE_PASSPOSRT_ROUTE } from "../routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradePassportInsurance',
  setup(__props) {

const store = useStore();
const router = useRouter();

const isShowInsuranceModal = ref(false);
const isOpenConfirmDelete = ref(false);
const confirmDeleteId = ref(null) as any;
const deleteLoader = ref(false);
const isLoading = ref(false);
const userInsuranceData = ref(null) as any;

const user = computed(() => store.getters[`${USER_STORE}/user`]);
const userInsurances = computed(
  () => store.getters[`${USER_STORE}/userInsurances`]
);
const getIsOpenTradePassportasViewMode = computed(
  () => store.getters[`${TRADE_ESTIMATE_STORE}/isOpenTradePassportasViewMode`]
);
const contractorTradePassportWorkstationId = computed(
  () =>
    store.getters[
      `${TRADE_ESTIMATE_STORE}/getContractorTradePassportWorkstationId`
    ]
);
const isUserProprtyOwner = computed(
  () =>
    user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER ||
    getIsOpenTradePassportasViewMode.value
);
const formatSum = (sum: any) => {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sum);
};

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const isWorkStationVerified = computed(() => {
  return (
    store.getters[`${WORKSTATION}/activeUserWorkstation`]
      ?.verificationStatus === UserVerificationStatusEnum.VERIFIED
  );
});
const isOuterEditInsurance = ref(false);
const getUserWorkStationFieldAccess = computed(
  () => store.getters[`${WORKSTATION}/getUserWorkStationFieldAccess`]
);

const onRouteToTradePassport = async () => {
  await router.push({ name: TRADE_PASSPOSRT_ROUTE });
};

const onClickAddNewInsurance = () => {
  isShowInsuranceModal.value = true;
};
const onClickCloseModel = () => {
  isShowInsuranceModal.value = false;
};
const onDeleteItem = (id: any) => {
  confirmDeleteId.value = id;
  isOpenConfirmDelete.value = true;
};

const onCloseConfirmDelete = () => {
  confirmDeleteId.value = null;
  isOpenConfirmDelete.value = false;
};
const onDeleteInsurance = async (insuranceId: string) => {
  try {
    await store.dispatch(`${USER_STORE}/removeUserInsurance`, {
      userId: user.value.id,
      userInsuranceId: insuranceId,
    });
    if (userInsurances.value.length === 0 && isWorkStationVerified.value) {
      const responce: any = await insurancesService.isInsuranceExpired(
        user.value.id
      );

      store.commit(
        `${INSURANCE_STORE}/setInsuranceExpired`,
        responce.isFreezed
      );
    }
    await store.dispatch(`${USER_STORE}/getAccountStatuses`);
  } catch (error) {
    console.log();
  }
};
const deleteItem = async () => {
  deleteLoader.value = true;
  await onDeleteInsurance(confirmDeleteId.value);
  deleteLoader.value = false;
  onCloseConfirmDelete();
};
const editInsurance = (insurance: object) => {
  isShowInsuranceModal.value = true;
  userInsuranceData.value = insurance;
  isOuterEditInsurance.value = true;
};
const clearData = () => {
  userInsuranceData.value = null;
};
const chipLabel = (status: any) => {
  if (UserVerificationStatusEnum.PENDING_VERIFICATION === status)
    return "Pending";
  else if (UserVerificationStatusEnum.REJECTED === status) return "Rejected";
  else if (UserVerificationStatusEnum.VERIFIED === status) return "Verified";
  else if (UserVerificationStatusEnum.NOT_ADDED === status) return "Not added";
};
const chipColor = (status: any) => {
  if (UserVerificationStatusEnum.PENDING_VERIFICATION === status)
    return "#FAA500";
  else if (UserVerificationStatusEnum.REJECTED === status) return "red";
  else if (UserVerificationStatusEnum.VERIFIED === status) return "green";
  else if (UserVerificationStatusEnum.NOT_ADDED === status) return "#7467B7";
};

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1;
  const year = date.getUTCFullYear();
  const formattedDay = day < 10 ? "0" + day : day;
  const formattedMonth = month < 10 ? "0" + month : month;
  return `${formattedDay}/${formattedMonth}/${year}`;
};

const isShowPendingBoard = computed(
  () =>
    isWorkStationVerified.value &&
    userInsurances.value?.some(
      (insurance: any) =>
        insurance?.userVerificationStatus ===
        UserVerificationStatusEnum.PENDING_VERIFICATION
    ) &&
    userInsurances.value?.some(
      (insurance: any) =>
        insurance?.userVerificationStatus ===
        UserVerificationStatusEnum.VERIFIED
    )
);

onBeforeMount(async () => {
  try {
    isLoading.value = true;
    if (user.value?.id && !userInsurances.value?.length) {
      if (isUserProprtyOwner.value) {
        await store.dispatch(`${USER_STORE}/setContractorInsurances`, {
          userId: user.value.id,
          workStationId: contractorTradePassportWorkstationId.value,
        });
      } else {
        await store.dispatch(`${USER_STORE}/setUserInsurances`, user.value.id);
      }
    }
  } catch (error) {
    console.log();
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Loader, {
            show: isLoading.value,
            class: "tw-z-10"
          }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: onRouteToTradePassport,
      class: "tw-flex tw-items-center tw-gap-[.1rem] tw-cursor-pointer tw-pb-4 tw-w-full"
    }, [
      _createVNode(_component_v_icon, { icon: "mdi-chevron-left" }),
      _createVNode(Text, {
        variant: "p",
        textWeight: "600"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Back")
        ]),
        _: 1
      })
    ]),
    (!isLoading.value && userInsurances.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (isShowPendingBoard.value)
            ? (_openBlock(), _createBlock(PendingVerifyNotice, {
                key: 0,
                content: "New insurance under review. Existing coverage valid."
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(Text, {
                  variant: "h6",
                  class: "rmd:!tw-text-[22px]",
                  lineHeight: "18px",
                  textAlign: "left"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isUserProprtyOwner.value ? "Insurances" : "Your Insurances"), 1)
                  ]),
                  _: 1
                }),
                _createVNode(Text, {
                  variant: "p",
                  textWeight: "600",
                  textColor: "rgba(12, 15, 74, 0.8)",
                  lineHeight: "18px",
                  textAlign: "left",
                  class: "md:!tw-hidden"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(userInsurances.value?.length) + " Results", 1)
                  ]),
                  _: 1
                })
              ]),
              (!isUserProprtyOwner.value)
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    variant: "secondary",
                    label: "+Add Insurance",
                    class: "!tw-w-auto md:!tw-min-h-[unset] md:!tw-px-2",
                    onClick: onClickAddNewInsurance
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userInsurances.value, (insurance, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["tw-w-full tw-flex tw-flex-col tw-gap-4 tw-py-4 tw-box-border", {
            'tw-border-b-dashed-custom': index !== userInsurances.value.length - 1,
            '!tw-pt-0': index === 0,
          }])
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(Text, {
                            variant: "h6",
                            class: "md:!tw-text-[.8rem]",
                            lineHeight: "18px",
                            textAlign: "left"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(insurance?.metadata?.insuranceName ||
                      insurance?.insurance?.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (
                      insurance?.userVerificationStatus ===
                        _unref(UserVerificationStatusEnum).PENDING_VERIFICATION &&
                      !_unref(isExpiredDate)(insurance?.metadata?.expiryDate)
                    )
                            ? (_openBlock(), _createBlock(PendingChip, {
                                key: 0,
                                class: "tw-w-[auto]",
                                label: "Pending Verification"
                              }))
                            : _createCommentVNode("", true),
                          (
                      insurance?.userVerificationStatus ===
                        _unref(UserVerificationStatusEnum).VERIFIED &&
                      !_unref(isExpiredDate)(insurance?.metadata?.expiryDate) &&
                      !isUserProprtyOwner.value
                    )
                            ? (_openBlock(), _createBlock(AcceptChip, {
                                key: 1,
                                class: "tw-w-[auto]",
                                label: "Accepted"
                              }))
                            : _createCommentVNode("", true),
                          (
                      insurance?.userVerificationStatus ===
                        _unref(UserVerificationStatusEnum).VERIFIED &&
                      !_unref(isExpiredDate)(insurance?.metadata?.expiryDate) &&
                      isUserProprtyOwner.value
                    )
                            ? (_openBlock(), _createBlock(AcceptChip, {
                                key: 2,
                                class: "tw-w-[auto]",
                                label: "Verified"
                              }))
                            : _createCommentVNode("", true),
                          (
                      insurance?.userVerificationStatus ===
                        _unref(UserVerificationStatusEnum).REJECTED &&
                      !_unref(isExpiredDate)(insurance?.metadata?.expiryDate)
                    )
                            ? (_openBlock(), _createBlock(RejectChip, {
                                key: 3,
                                class: "tw-w-[auto]",
                                label: "Rejected"
                              }))
                            : _createCommentVNode("", true),
                          (_unref(isExpiredDate)(insurance?.metadata?.expiryDate))
                            ? (_openBlock(), _createBlock(RejectChip, {
                                key: 4,
                                class: "tw-w-[auto]",
                                label: "Expired"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(Text, {
                          variant: "p",
                          textColor: "rgba(12, 15, 74, 0.8)",
                          lineHeight: "18px",
                          class: "md:!tw-text-[.7rem]",
                          textAlign: "left"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Coverage: " + _toDisplayString(_unref(appFilters).formatToCurrency(insurance?.metadata?.sum)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(Text, {
                          variant: "p",
                          textColor: "rgba(12, 15, 74, 0.8)",
                          lineHeight: "18px",
                          class: "md:!tw-text-[.7rem]",
                          textAlign: "left"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Expiry: " + _toDisplayString(_unref(appFilters).formatToDate(insurance?.metadata?.expiryDate)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      (getUserWorkStationFieldAccess.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (!isUserProprtyOwner.value)
                              ? (_openBlock(), _createBlock(BlueCircularPencilIcon, {
                                  key: 0,
                                  class: "md:!tw-min-w-[21px] md:!tw-w-[21px] md:!tw-h-[21px]",
                                  onClick: ($event: any) => (editInsurance(insurance))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (!isUserProprtyOwner.value)
                              ? (_openBlock(), _createBlock(GrayCircularTrashIcon, {
                                  key: 1,
                                  class: "md:!tw-min-w-[21px] md:!tw-w-[21px] md:!tw-h-[21px]",
                                  onClick: ($event: any) => (onDeleteItem(insurance.id))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value && !userInsurances.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("img", {
                src: require('../../../assets/images/trade_insurance_empty.png'),
                alt: "",
                class: "tw-w-full"
              }, null, 8, _hoisted_16)
            ]),
            (!isUserProprtyOwner.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24)),
            _createElementVNode("div", _hoisted_25, [
              (getUserWorkStationFieldAccess.value && !isUserProprtyOwner.value)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: onClickAddNewInsurance,
                    class: "button button-purple",
                    width: "100%"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("add new insurance")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (isShowInsuranceModal.value)
      ? (_openBlock(), _createBlock(AddInsuranceModal, {
          key: 3,
          onOnClickCloseTab: onClickCloseModel,
          userInsuranceData: userInsuranceData.value,
          isOuterEditInsurance: isOuterEditInsurance.value,
          onClearUserInsuranceData: clearData
        }, null, 8, ["userInsuranceData", "isOuterEditInsurance"]))
      : _createCommentVNode("", true),
    (isOpenConfirmDelete.value)
      ? (_openBlock(), _createBlock(ConfirmDeleteModal, {
          key: 4,
          type: "insurance",
          label: "You're about to delete your insurance.",
          onOnClose: onCloseConfirmDelete,
          onOnDelete: deleteItem,
          loading: deleteLoader.value
        }, null, 8, ["loading"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})